import { formatPercentageTwoDp } from "@/utils/numberFormattingUtils";

import { TOP_PLAYER_CATEGORY } from '../topPlayerCategories';

const getDisplayCategoryForTooltip = (label: string) => {
  switch (label) {
    case TOP_PLAYER_CATEGORY.podcastPlayerApps:
      return 'App';
    case TOP_PLAYER_CATEGORY.webPodcastPlayers:
      return 'Web Player';
    default:
      return label;
  }
};

export const TopPlayersPercentageListTooltipContent = ({
  label,
  value,
  plays,
  percentages
}: {
  label: string;
  value: number;
  plays: number;
  percentages: Array<{ label: string; value: number; }>;
}) => {
  const hasSocialPlatforms = percentages.some(
    (p) => p.label.toLowerCase() === TOP_PLAYER_CATEGORY.socialPlatforms.toLowerCase()
  );

  return (
    <div>
      <p className="mb-2 text-sm font-medium ">{label}</p>
      <p className="text-md font-medium text-[#4040A8]">{formatPercentageTwoDp(value)}%</p>
      <p className="flex flex-col text-sm">
        <span className="text-textMedGrey mb-2">
          of your total downloads or views happen on <strong>{label}</strong>. That is a total of:
        </span>
      </p>
      <p className="text-md font-medium text-[#4040A8]">{plays.toLocaleString()}</p>
      <p className="flex flex-col text-sm">
        <span className="text-sm text-textMedGrey ">
          downloads or views
        </span>
      </p>
      {hasSocialPlatforms ? (
        <p className="text-xs text-textMedGrey mt-2">
          A breakdown of consumption on the app and web player is not available for {label} at the moment.
        </p>
      ) : (
        <>
          <p className="text-xs text-textMedGrey mt-2">Out of these:</p>
          <ul className="list-disc list-inside space-y-1 text-xs text-textMedGrey">
            {percentages.map((p) => (
              <li key={p.label}>
                <strong>{formatPercentageTwoDp(p.value)}%</strong> happen on the <strong>{getDisplayCategoryForTooltip(p.label)}</strong>
              </li>
            ))}
          </ul>
        </>
      )}
    </div>
  );
};
